import { colors } from '../../styles/theme';
import {
  appModalActionsSx,
  appModalCloseButtonSx,
  appModalContentSx,
  appModalHeaderDividerSx,
  appModalPaperSx,
  appModalSubtitleSx,
  appModalTitleBarSx,
  appModalTitleSx,
} from '../appModalChrome.styles';

const TEXT_PRIMARY = '#F9FAFB';
const TEXT_SECONDARY = '#ABABAB';
const TEXT_MUTED = 'rgba(255,255,255,0.45)';
const DANGER = '#EE5757';

export const brandsTextColors = {
  primary: TEXT_PRIMARY,
  secondary: TEXT_SECONDARY,
  muted: TEXT_MUTED,
  danger: DANGER,
};

/** Encima del diálogo de compartir, desde donde también se abre. */
export const BRANDS_MODAL_Z_INDEX = 2200;

/**
 * El Tooltip de MUI porta a `body` con z-index 1500. Sin esto queda detrás
 * del modal y solo se ve el pedazo que asoma por el borde.
 */
export const brandsTooltipSlotProps = {
  popper: { sx: { zIndex: BRANDS_MODAL_Z_INDEX + 1 } },
};

const SCROLLBAR_SX = {
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(255,255,255,0.10) transparent',
  '&::-webkit-scrollbar': { width: 6 },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(255,255,255,0.10)',
    borderRadius: 8,
  },
  '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(255,255,255,0.18)' },
};

export const brandsDialogPaperSx = {
  ...appModalPaperSx,
  height: { xs: 'min(520px, 70vh)', sm: 'min(540px, 78vh)' },
  maxHeight: { xs: 'min(520px, 70vh)', sm: 'min(540px, 78vh)' },
};

export const brandsDialogTitleBarSx = appModalTitleBarSx;

export const brandsDialogTitleSx = appModalTitleSx;

export const brandsDialogSubtitleSx = {
  ...appModalSubtitleSx,
  mt: 0,
  px: 0,
  flex: 1,
  minWidth: 0,
};

export const brandsSubtitleRowSx = {
  mt: 2,
  px: '20px',
  mb: 0,
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1.5,
  flexShrink: 0,
};

/** Mismo chrome que el + de “Agregar nueva lista”. */
export const brandsAddButtonSx = {
  width: 28,
  height: 28,
  minWidth: 28,
  flexShrink: 0,
  p: 0,
  borderRadius: '4px',
  border: `1px solid ${colors.border}`,
  bgcolor: colors.backgroundSurface,
  color: colors.textPanelTitle,
  boxSizing: 'border-box',
  '&:hover': {
    bgcolor: 'rgba(255,255,255,0.06)',
    borderColor: colors.textPanelTitle,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 16,
    color: colors.textPanelTitle,
  },
};

export const brandsDialogHeaderDividerSx = appModalHeaderDividerSx;

export const brandsDialogContentSx = {
  ...appModalContentSx,
  overflow: 'hidden',
};

export const brandsDialogActionsSx = appModalActionsSx;

export const brandsCloseButtonSx = appModalCloseButtonSx;

export const brandsSectionLabelSx = {
  display: 'block',
  color: TEXT_PRIMARY,
  fontSize: '11px',
  fontWeight: 600,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
};

export const brandsHelperTextSx = {
  color: TEXT_MUTED,
  fontSize: '12px',
  lineHeight: 1.45,
};

export const brandsErrorTextSx = {
  color: colors.error,
  fontSize: '13px',
  lineHeight: 1.45,
};

export const brandsFieldSx = {
  '& .MuiOutlinedInput-root': {
    color: TEXT_PRIMARY,
    fontSize: '14px',
    borderRadius: '8px',
    bgcolor: colors.backgroundDark,
    '& fieldset': { borderColor: colors.border },
    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.28)' },
    '&.Mui-focused fieldset': { borderColor: colors.primary },
    '&.Mui-disabled': { bgcolor: 'rgba(255,255,255,0.03)' },
  },
  '& .MuiOutlinedInput-input::placeholder': { color: TEXT_MUTED, opacity: 1 },
  '& .MuiInputLabel-root': { color: TEXT_SECONDARY, fontSize: '13px' },
  '& .MuiInputLabel-root.Mui-focused': { color: colors.primaryLight },
  '& .MuiFormHelperText-root': { color: TEXT_MUTED, fontSize: '11px', mx: 0, mt: 0.5 },
  '& .MuiFormHelperText-root.Mui-error': { color: colors.error },
};

export const brandsPrimaryButtonSx = {
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '13px',
  borderRadius: '8px',
  bgcolor: colors.primary,
  color: '#FFFFFF',
  boxShadow: 'none',
  '&:hover': { bgcolor: colors.primaryHover, boxShadow: 'none' },
  '&.Mui-disabled': { bgcolor: 'rgba(72,146,145,0.35)', color: 'rgba(255,255,255,0.55)' },
};

export const brandsSecondaryButtonSx = {
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '13px',
  borderRadius: '8px',
  color: TEXT_SECONDARY,
  borderColor: colors.border,
  '&:hover': { borderColor: 'rgba(255,255,255,0.28)', bgcolor: 'rgba(255,255,255,0.04)' },
};

export const brandsDangerButtonSx = {
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '13px',
  borderRadius: '8px',
  color: DANGER,
  borderColor: 'rgba(238,87,87,0.45)',
  '&:hover': { borderColor: DANGER, bgcolor: 'rgba(238,87,87,0.10)' },
};

/** Pozo de la lista: mismo fondo que el body de Mis listas; llena el alto del modal. */
export const brandsListWellSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  width: '100%',
  flex: 1,
  minHeight: 0,
  p: '8px',
  borderRadius: '8px',
  bgcolor: '#141414',
  boxSizing: 'border-box',
  overflowY: 'auto',
  ...SCROLLBAR_SX,
};

/** Card de identidad — mismo chrome que las cards de lista. */
export const brandsCardSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.25,
  px: '12px',
  py: '10px',
  borderRadius: '8px',
  border: 'none',
  bgcolor: colors.backgroundDark,
  minWidth: 0,
  boxSizing: 'border-box',
  transition: 'background-color 0.15s ease',
  '&:hover': {
    bgcolor: '#2a2a2a',
  },
};

/** Label arriba del input, como el formulario de marca de siempre. */
export const brandsFieldLabelSx = {
  display: 'block',
  color: TEXT_PRIMARY,
  fontSize: '13px',
  mb: 0.5,
};

export const brandsLogoBarSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.75,
  width: '100%',
  p: 1.5,
  borderRadius: '8px',
  border: `1px solid ${colors.border}`,
  bgcolor: colors.backgroundDark,
  boxSizing: 'border-box',
};

export const brandsLogoPreviewSx = {
  width: 72,
  height: 72,
  flexShrink: 0,
  borderRadius: '8px',
  border: `1px solid ${colors.border}`,
  bgcolor: colors.backgroundSurface,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
};

export const brandsLogoBoxSx = {
  width: 44,
  height: 44,
  flexShrink: 0,
  borderRadius: '8px',
  border: `1px solid ${colors.border}`,
  bgcolor: colors.backgroundSurface,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
};

export const brandsLogoImageSx = {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
};

export const brandsCardNameSx = {
  color: TEXT_PRIMARY,
  fontSize: '14px',
  fontWeight: 600,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const brandsCardMetaSx = {
  color: TEXT_MUTED,
  fontSize: '12px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const brandsDefaultChipSx = {
  height: 20,
  fontSize: '10px',
  fontWeight: 600,
  color: colors.primaryLight,
  bgcolor: 'rgba(72,146,145,0.16)',
  border: `1px solid ${colors.primary}`,
  '& .MuiChip-label': { px: 0.75 },
};

export const brandsIconButtonSx = {
  color: TEXT_MUTED,
  '&:hover': { color: colors.primaryLight, bgcolor: 'rgba(72,146,145,0.12)' },
  '&.Mui-disabled': { color: 'rgba(255,255,255,0.18)' },
};

export const brandsSwatchInputStyle = {
  width: 40,
  height: 40,
  padding: 0,
  border: `1px solid ${colors.border}`,
  borderRadius: '8px',
  background: 'transparent',
  flexShrink: 0,
};

export const brandsEmptyStateSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: 1,
  flex: 1,
  minHeight: 0,
  px: 2,
  py: 2,
};

export const brandsSkeletonSx = { bgcolor: colors.backgroundDark, borderRadius: '8px' };
